import ExerciseHelpers from "helpers/ExerciseHelpers";
import MetricHelpers from "helpers/MetricHelpers";
import UnitHelper from "helpers/UnitHelper";
import usePreferences from "hooks/usePreferences";
import { useCallback } from "react";
import type { CircuitMetric, ExerciseMetric, ScoreMetadata } from "types";

function useUnitNotation() {
  const [preferences] = usePreferences();

  const unitNotation = useCallback(
    (metricMetadata?: ExerciseMetric | CircuitMetric | ScoreMetadata | null) => {
      const displayMetadata = preferences.imperialSystemEnabled
        ? metricMetadata?.displayMetadata?.imperial
        : metricMetadata?.displayMetadata?.metric;

      const unit = displayMetadata?.unit ?? MetricHelpers.getSourceUnit(metricMetadata) ?? null;
      return UnitHelper.getUnitNotation(unit);
    },
    [preferences.imperialSystemEnabled]
  );

  const formatWithUnit = useCallback(
    (value: number, metricMetadata?: ExerciseMetric | CircuitMetric | ScoreMetadata | null) => {
      const displayMetadata = preferences.imperialSystemEnabled
        ? metricMetadata?.displayMetadata?.imperial
        : metricMetadata?.displayMetadata?.metric;

      const unit = displayMetadata?.unit ?? MetricHelpers.getSourceUnit(metricMetadata) ?? null;

      // isSpecialCase
      if (ExerciseHelpers.isSpecialCaseMetric(metricMetadata, preferences.imperialSystemEnabled)) {
        return UnitHelper.processUnit(value, {
          from: MetricHelpers.getSourceUnit(metricMetadata),
          to: displayMetadata?.unit,
          decimals: displayMetadata?.decimals,
        }).formatted;
      }

      return UnitHelper.appendUnit(value, unit);
    },
    [preferences.imperialSystemEnabled]
  );

  return { unitNotation, formatWithUnit };
}

export default useUnitNotation;
